import React, { useState } from 'react';
import { Layout } from '@components';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { email } from '@config';

const StyledContactSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 70vh;
  padding: 0;
  padding-top: 50px;
 
  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }
  * {
    box-sizing: border-box;
  }

  body {
    background: #9de0a3;
    min-width: 320px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 20px;
  }
 
  .alert {
    text-align: center;
    margin: 10px;
    border-radius: 10px;
    padding: 20px;
    background-color: #f44336;
    color: white;
  }
  .success {
    text-align: center;
    margin: 10px;
    border-radius: 10px;
    padding: 20px;
    background-color: #2FB986;
    color: white;
  }
  

  .closebtn {
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: black;
  }
  
  .form-container {
    margin-top: 50px;
    padding: 0 10%;
    width: 100%;
    section {
      width: 100%;
      padding: 20px;
      background: var(--lightest-navy);
      margin-top: 50px;
      border-radius: 10px;
      z-index: 1000;
      backdrop-filter: saturate(180%) blur(10px);
      @media (max-width: 720px) {
        margin-top: 70px;
      }
     
      .input-container {
        label {
        font-family: var(--font-sans);
          display: block;
          margin-bottom: 5px;
          font-size: 16px;
          color:var(--green);
        }
        input,
        textarea {
          font-family: var(--font-sans);
          width: 100%;
          padding: 5px 10px;
          height: 40px;
          border-radius: 5px;
          border: none;
          background: var(--white);
          box-shadow: 2px 2px 0 #a3adcc;

          &:focus {
            outline: none;
            background: var(--white);
          }
        }
        textarea {
          height: 122px;
          padding: 15px 10px;
          resize: none;
        }
        padding: 10px;
      }
    }
    
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
    @media (max-width: 992px) {
      padding: 0 5%;
    }
    @media (max-width: 768px) {
      margin-bottom: 50px;
      section {
        width: 100%;
        margin: 0;
        &.left {
          margin-bottom: -30px;
        }
      }
      
      }
    }
  }
`;
const Message = ({ location }) => {
  const [formData, setFormData] = useState({ name: '', subject: '', message: '' });
  const [showAlert, setShowAlert] = useState(false);

  const handleSend = (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.subject.trim() || !formData.message.trim()) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    // Create mailto link with pre-filled fields
    const subject = encodeURIComponent(formData.subject);
    const body = encodeURIComponent(`Name: ${formData.name}\n\n${formData.message}`);
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    
    // Open email client
    window.location.href = mailtoLink;
  };
  return (
    <Layout location={location}>
      <Helmet title="Message" />

      <StyledContactSection>
        {/* <h2 style={{ textAlign: 'center' }}>Contact Me</h2> */}
        <div className="form-container">
          <section>
            <div className="input-container">
              <label htmlFor="name">Name</label>
              <input
                placeholder="Send 📧 for future communication"
                type="text"
                id="name"
                value={formData.name}
                onChange={e => {
                  setFormData({ ...formData, name: e.target.value });
                }}
              />
            </div>
            <div className="input-container">
              <label htmlFor="subject">Subject</label>
              <input
                placeholder="Random 💭/💡 you have in your 🧠"
                type="text"
                id="subject"
                value={formData.subject}
                onChange={e => {
                  setFormData({ ...formData, subject: e.target.value });
                }}
              />
            </div>
            <div className="input-container">
              <label htmlFor="message">Message</label>
              <textarea
                placeholder="Describe your idea. 💭"
                name="message"
                id="message"
                value={formData.message}
                onChange={e => {
                  setFormData({ ...formData, message: e.target.value });
                }}
              ></textarea>
            </div>
          </section>
          {showAlert && (
            <div className="alert">
              <strong>👀 Please fill in all fields!</strong> I can see you.
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button className="email-link" onClick={handleSend}>
              Send 📬
            </button>
          </div>
        </div>
      </StyledContactSection>
    </Layout>
  );
};

export default Message;
